export const isMagazineArticlePage = (
  route: ReturnType<typeof useRoute>
): boolean => {
  const segments = route.path.split('/').filter(Boolean)
  return segments[1] === 'magazine' && !!route.params.articleSlug
}

export const isEventListPage = (
  route: ReturnType<typeof useRoute>
): boolean => {
  const segments = route.path.split('/').filter(Boolean)
  const first = segments[1]
  return (
    first === 'teamevent' ||
    first === 't' ||
    first === 'c' ||
    !!route.params.location
  )
}
